import { render } from "./Calendar.vue?vue&type=template&id=367796ee&ts=true"
import script from "./Calendar.vue?vue&type=script&setup=true&lang=ts"
export * from "./Calendar.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/calendar/Calendar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "367796ee"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('367796ee', __exports__)) {
    api.reload('367796ee', __exports__)
  }
  
  module.hot.accept("./Calendar.vue?vue&type=template&id=367796ee&ts=true", () => {
    api.rerender('367796ee', render)
  })

}


export default __exports__